/**
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module special-characters/specialcharacterstext
 */

import { Plugin } from 'ckeditor5';

/**
 * A plugin that provides special characters for the "Text" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersText ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersCheckMarks extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'SpecialCharactersCheckMarks';
    }

    /**
     * @inheritDoc
     */
    init() {
        const editor = this.editor;
        const t = editor.t;

        editor.plugins.get('SpecialCharacters').addItems('Symbol', [
            {character: '✓', title: t('CHECK MARK')},
            { title: 'Ellipsis', character: '…' },
            { title: 'n-dash', character: '–' },
            { title: 'm-dash', character: '—' },
            { title: 'Degree symbol', character: '°' },
            { title: 'Plus/minus sign', character: '±' },
            { title: 'Superscript 1', character: '¹' },
            { title: 'Superscript 2', character: '²' },
            { title: 'Superscript 3', character: '³' },
            { title: 'Multiplication', character: '×' },
            { title: 'Division', character: '÷' },
            { title: 'Minus sign', character: '-' },
            { title: 'Registered Trademark', character: '®' },
            { title: 'Trademark', character: '™' },
            { title: 'Copyright', character: '©' },
            { title: 'microgram', character: 'µ' },
            { title: 'tilde', character: '~' },
            { title: 'Octothorpe', character: '#' },
            { title: 'Percent sign', character: '%' },
            { title: 'Circumflex, caret', character: '^' },
            { title: 'A plus over ring', character: 'Å' },
            { title: 'a plus over ring', character: 'å' },
            { title: 'Ohm', character: 'Ω' },
            { title: 'less than', character: '<' },
            { title: 'greater than', character: '>' },
            { title: 'grave accent', character: '`' },
            { title: 'vertical bar', character: '|' },
            { title: 'Interrobang', character: '‽' },
            { title: 'Pound sterling sign', character: '£' },
            { title: 'Euro sign', character: '€' },
        ]);
    }
}
